export default __webpack_public_path__ + "static/media/157.67ab3440.gif";